import type { FC, ReactElement } from 'react'

export type WizardStepArgs = {
  children: ReactElement
  name: string | ReactElement
  previousButtonText?: string | ReactElement
  skipButtonText?: string | ReactElement
  nextButtonText?: string | ReactElement
  displayNavigation?: boolean
  isValid?: boolean
  isFinalStep?: boolean
  isSkippable?: boolean
  isStarted?: boolean
  isHidden?: boolean
}

export const WizardStep: FC<WizardStepArgs> = props => (
  <div tabIndex={-1}>
    <div {...props} />
  </div>
)

export default WizardStep
